import { useBreakpointValue } from "@gluestack-style/react";
import { IModalRefProps } from "@repo/core/components/layout/Modal/types";
import { ConfirmStoreModalProps } from "@repo/core/components/layout/ModalTemplate/ConfirmStoreModal/types";
import { useStoresAndShopkeepersStore } from "@repo/core/stores/storesAndShopkeepers";
import { RefObject, useState } from "react";

export const useConfirmStoreModalController = ({
  onSelectCancel,
  ref
}: ConfirmStoreModalProps & { ref: RefObject<IModalRefProps> }) => {
  const isMobile = useBreakpointValue({
    base: true,
    md: false
  });
  const { selectedStore, setShowCorrectStoreAlert } =
    useStoresAndShopkeepersStore();

  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleOnChangeDontShowAgain = (dontShowAgain: boolean) => {
    setDontShowAgain(dontShowAgain);
  };

  const handleOnSelectConfirm = () => {
    setShowCorrectStoreAlert(!dontShowAgain);
    ref?.current?.close();
  };

  const handleOnSelectCancel = () => {
    setShowCorrectStoreAlert(!dontShowAgain);
    onSelectCancel();
  };

  return {
    isMobile,
    selectedStore,
    handleOnChangeDontShowAgain,
    handleOnSelectConfirm,
    handleOnSelectCancel
  };
};
